import { SuiteManifest } from '../manifest';
import { deliveryRoutes } from './routes';

export const deliveryManifest: SuiteManifest = {
  id: 'delivery',
  name: 'Support & Delivery',
  basePath: '/delivery',
  icon: 'briefcase',
  description: 'Client projects, milestone execution, and billable time logs.',
  requiredPermission: 'platform.user.manage',
  nav: [
    { label: 'Project Tracking', path: '/delivery/projects', icon: 'briefcase', permission: 'platform.user.manage', group: 'Delivery', status: 'live' },
    { label: 'Time Tracking', path: '/delivery/time', icon: 'history', permission: 'platform.user.manage', group: 'Delivery', status: 'live' },
  ],
  routes: deliveryRoutes,
};

export default deliveryManifest;
